import McmCustomConfig from '~/tenants/mcm/performable/custom/McmCustomConfig';
import McmJob from '~/tenants/mcm/model/McmJob';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import { TenantJobLine } from '~/lib/model';
import { Big } from 'big.js';

export default class McmCustomJob extends McmJob<typeof McmCustomConfig> {
  get performable() {
    return McmCustomConfig;
  }

  defaultValue(): ZodVersionedMetadata<(typeof McmCustomConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
      description: '',
    };
  }

  revenueLines(): TenantJobLine[] {
    const lines: TenantJobLine[] = [];

    lines.push({
      id: 'custom',
      description: this.metadata.description,
      amount: new Big(this.metadata.revenue ?? '0'),
      ...(this.metadata.taxable ? { taxable: true } : {}),
    });

    return lines;
  }

  get hidden() {
    return true;
  }
}
